import { useEffect, useRef } from 'react';
import { useUser } from '@clerk/clerk-react';
import { backfillAttributionMetadata, captureAttributionFromUrl, isFreshSignup } from '@arthelper/shared/attribution';

/**
 * Capture UTM params, ad-network click IDs (fbclid, gclid) and the forwarded first
 * visit from the current URL into localStorage so they survive cross-domain auth
 * round-trips and can be attached to Amplitude `identify` / event properties later.
 *
 * For a just-created account it also fills whatever attribution Clerk's
 * unsafeMetadata is missing: `<SignIn>` OAuth lands new accounts here straight from
 * `/signin/sso-callback` with none, and the API's `user.updated` webhook copies the
 * top-up into the account's attribution row.
 *
 * Storage shape (matches town-square and marketing):
 *   localStorage['utm_params']             — last-touch JSON blob
 *   localStorage['first_visit_utm_params'] — first-touch JSON blob (set-once)
 */
export function useUtmParams() {
  const { isLoaded, user } = useUser();
  const backfilled = useRef(false);

  useEffect(() => {
    captureAttributionFromUrl();
  }, []);

  useEffect(() => {
    if (!isLoaded || !user || backfilled.current) return;
    if (!isFreshSignup(user.createdAt)) return;
    backfilled.current = true;
    backfillAttributionMetadata(user).catch((err) => {
      console.error('[attribution] failed to backfill signup metadata', err);
    });
  }, [isLoaded, user]);
}
